
<template>
    <div class="center">
      <vs-dialog prevent-close v-model="active">
        <template #header>
          <h4 class="not-margin">
            Eliminar subcategoría
          </h4>
        </template>
        <div class="con-form">
            ¿Esta seguro de eliminar <strong>{{selectInfo.codigo_detalle}}</strong>?
        </div>

        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false">
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="postEliminarSubcategoria()">
                        Aceptar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import academico from '../../../../../api/requests/academico'
export default {
    props:[
        'value',
        'selectInfo',
    ],
    data:() => ({
        active: false,
        errorFields: [],
        institucion: '',
        institucionId: (new Date()).getTime(),
        cicloEscolar: '',
        ciclosEscolares: [],
        cicloId: (new Date()).getTime(),
        codigo: '',
        codigoId: (new Date()).getTime(),
        categoria: '',
        loadingSelect: false
    }),
    methods: {
        async postEliminarSubcategoria(){
            const loading = this.$vs.loading()
            try{
                const payload = {
                    subcategoria_id: this.selectInfo.subcategoria_id
                }
                const { data: response } = await academico.postEliminarSubcategoria(payload)
                loading.close()
                this.active = false
                this.$emit('refreshTable')
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa.',
                    text: 'Se ha eliminado con éxito el registro.'
                })
            }catch{
                loading.close()
                this.active = false
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Algo salió mal.',
                    text: 'Póngase en contacto con el administrador.'
                })
            }
        },
    },
    watch:{
      value (val) {
          this.active = val
      },
      async active (val) {
          if (!val){
              this.$emit('input', val);
          }
      },
    }
}
</script>